module.exports = __webpack_public_path__ + "static/media/desbravador_p.192bc57b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/desbravador_p.png
// module id = 1180
// module chunks = 0